import { _ as e } from "./export-cdcbfb2b.js";
import { a as t } from "./array-iteration-759bfbfa.js";
import { b as d } from "./create-property-f9780ed1.js";
var o = e, i = t.findIndex, f = d, r = "findIndex", n = !0;
r in [] && Array(1)[r](function() {
  n = !1;
});
o({ target: "Array", proto: !0, forced: n }, {
  findIndex: function(a) {
    return i(this, a, arguments.length > 1 ? arguments[1] : void 0);
  }
});
f(r);
